import React from 'react'

const Opportunities = () => {
    return (
        <>
            <div className="choose-area pt-80 pb-80" style={{marginTop:"-110px"}}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="choose-content wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="choose-content-info">
                                    <div className="site-heading mb-0">
                                        <span className="site-title-tagline" style={{ color: "white" }}><i className="far fa-book-open-reader" /> Why Choose Us</span>
                                        <h2 className="site-title text-white mb-10">We Are Expert &amp; <span>Do Our Best</span> For Your Goal</h2>
                                        <p className="text-white" style={{ textAlign: "justify" }}>
                                            Welcome to Priyadarshani Convent High School, Satna! We are a reputable institution dedicated to providing quality education and holistic development opportunities to students. Our aim is to empower every student to achieve their goals and become responsible citizens.
                                            <br /> <b>- Experienced faculty and modern facilities</b>
                                            <br /> <b>- Emphasis on academics, sports, arts, and cultural activities</b>
                                            <br /> <b>- Various co-curricular activities for overall growth</b>
                                        </p>
                                        <p className="text-white" style={{ textAlign: "justify" }}>
                                            Our campus is equipped with smart classrooms, well-stocked libraries, science and computer labs, playgrounds, and a clean, secure environment to support effective learning.
                                            We follow interactive and innovative teaching methods that encourage critical thinking, curiosity, and confidence in students.
                                            Discipline, respect, integrity, and responsibility are core principles we instill in every student to prepare them for future challenges.
                                            We maintain transparent communication with parents and believe in building strong school–parent partnerships for a child’s overall success.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="choose-img wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <img src="assets/school/Why Choose.png" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Opportunities